__turbopack_context__.v({
  "accordionContainer": "navigation-module-scss-module__VLSPIa__accordionContainer",
  "accordionHead": "navigation-module-scss-module__VLSPIa__accordionHead",
  "column": "navigation-module-scss-module__VLSPIa__column",
  "ctaRed": "navigation-module-scss-module__VLSPIa__ctaRed",
  "item": "navigation-module-scss-module__VLSPIa__item",
  "menu": "navigation-module-scss-module__VLSPIa__menu",
  "menuItems": "navigation-module-scss-module__VLSPIa__menuItems",
  "navIcon": "navigation-module-scss-module__VLSPIa__navIcon",
  "navigation": "navigation-module-scss-module__VLSPIa__navigation",
  "title": "navigation-module-scss-module__VLSPIa__title",
});
